import PeriodScoreMapper from './period-score-mapper';

const PeriodScoreModel = {
    mapper: PeriodScoreMapper,

    awayTeamScore: {
        fieldName: 'a',
        type: Number,
    },

    homeTeamScore: {
        fieldName: 'h',
        type: Number,
    },

    periodNumber: {
        fieldName: 'p',
        type: Number,
    },
};

export default PeriodScoreModel;
